module.exports = __webpack_public_path__ + "media/images/emblems/Bleienbach-coat_of_arms-c147356fa1d8d716086d82ab87a9646b.svg";